import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-SidebarEdit",
  "use": "svg-icon-SidebarEdit-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-SidebarEdit\"><path fill=\"#D8D8D8\" d=\"M2.659 11.809a.743.743 0 0 1-.464.19H.274A.271.271 0 0 1 0 11.725V9.804c0-.151.086-.36.19-.464l7.3-7.3a.272.272 0 0 1 .384.003l2.082 2.081c.107.107.107.28.004.384l-7.301 7.301zm9.136-9.137l-.632.632a.274.274 0 0 1-.384-.003l-2.082-2.08a.273.273 0 0 1-.002-.385l.632-.633c.285-.268.559-.274.823 0l1.645 1.646c.278.275.269.559 0 .823z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol